import axios from "axios";
import { host_dev, host_local, host_prod } from "../../helper/config";

export const API_CODE = {
    GET_CART: 'carts',
    GET_CART_SUMMARY: 'cart_summary',
    GET_TICKET: 'tickets',
    GET_BANNER: 'banners',
    GET_BANNER_GROUP: 'banner_groups',
    GET_BANNER_DETAIL: 'banner_detail',
    GET_TICKET_SUMMARY: 'ticket_summary',
    GET_ROUTE: 'routes',
    GET_BOAT: 'boats',
    POST_UPDATE_CART: 'update_cart',
    POST_SEND_ZNS: 'send_zns',
    POST_UPDATE_TICKET: 'update_ticket',
    POST_UPDATE_BANNER: 'update_banner',
    POST_UPDATE_BANNER_DETAIL: 'update_banner_detail',
    POST_ADD_BANNER: 'add_banner',
    POST_UPDATE_BANNER_GROUP: 'update_banner_group',
    POST_ADD_BANNER_GROUP: 'add_banner_group',
    POST_ADD_ADMIN_TOKEN: 'add_admin_token',
}

export const GET_HOST = () => {
    if (!axios.defaults.baseURL) {
        const environment = localStorage.getItem('ENV');
        axios.defaults.baseURL = environment === 'PROD' ? host_prod : environment === 'DEV' ? host_dev : host_local;
    }
}

export const SET_HOST = (environment) => {
    localStorage.setItem('ENV', environment);
    axios.defaults.baseURL = environment === 'PROD' ? host_prod : environment === 'DEV' ? host_dev : host_local;
}